import MainRouter from "./router";

const Router = () => {
  return <MainRouter />;
};

export default Router;
